/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-twitter': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.45 15.588a7.975 7.975 0 008.025-8.025v-.37c.547-.4 1.02-.893 1.4-1.455a5.819 5.819 0 01-1.619.443 2.85 2.85 0 001.25-1.562 5.556 5.556 0 01-1.787.687 2.825 2.825 0 00-4.813 2.569 7.994 7.994 0 01-5.812-2.944 2.819 2.819 0 00.875 3.75 2.794 2.794 0 01-1.25-.35v.032a2.831 2.831 0 002.219 2.78c-.408.11-.835.127-1.25.05A2.819 2.819 0 007.3 13.126c-.994.8-2.23 1.24-3.506 1.25a6.106 6.106 0 01-.669-.056 7.981 7.981 0 004.325 1.25"/>'
  }
})
